export function makeCancelable(p) {
  const output = new Promise((resolve, reject) => p
    .then(results => output.isCanceled ? reject({canceled: true}) : resolve(results))
    .catch(err => output.isCanceled ? reject({canceled: true}) : reject(err)))
    .finally(() => output.isFinished = true);

  output.isCanceled = output.isCanceled || false;
  output.isFinished = output.isFinished || false;

  output.cancel = () => output.isCanceled = true;

  return output;
}
